import type { Theme } from '@esign/contracts'
import { derivePalette } from '@esign/theme'

export function applyTheme(theme: Theme): void {
  const root = document.documentElement
  for (const [name, value] of Object.entries(derivePalette(theme).tokens)) {
    root.style.setProperty(`--${name}`, value)
  }
}
